import Link from 'next/link';
import styles from './styles.module.css';
import clsx from 'clsx';
import { useMemo } from 'react';

export type Props = {
  link?: string;
  text: string;
  description?: string;
  descriptionLink?: string;
  button?: React.JSX.Element;
  gap?: number;
  navigationBar?: React.JSX.Element;
  anchor?: string;
  variant?: string;
};

export const Title = ({
  text,
  link,
  description,
  descriptionLink,
  button,
  gap,
  navigationBar,
  anchor,
  variant,
}: Props) => {
  const dynamicStyle = useMemo(() => {
    if (variant === 'home') {
      return {
        classContainer: styles.container_home,
      };
    }
    if (variant === 'twocolumns') {
      return {
        classContainer: styles.container_twocolumns,
      };
    }
    return {
      classContainer: null,
    };
  }, [variant]);
  const dynamicFont = useMemo(() => {
    if (variant === 'home') {
      return styles.fontHome;
    }
    return null;
  }, [variant]);

  const dynamicContent = useMemo(() => {
    if (variant === 'twocolumns') {
      return (
        <div className={styles.info}>
          <div>
            <h1 className={styles.title}>{text}</h1>
            {(description || descriptionLink) && (
              <h2
                className={clsx(
                  styles.desc_twocolumns,
                  styles.topPadding,
                  dynamicFont
                )}
              >
                {description && description}
                {descriptionLink && link ? (
                  <Link
                    prefetch={false}
                    href={link}
                    className={styles.desc_link}
                  >
                    {descriptionLink}
                  </Link>
                ) : null}
              </h2>
            )}
            {button}
          </div>
          <div className={styles.navBar}>{navigationBar}</div>
        </div>
      );
    }

    return (
      <div>
        <h1 className={styles.title}>{text}</h1>
        {navigationBar}
        {(description || descriptionLink) && (
          <h2 className={clsx(styles.desc, styles.topPadding, dynamicFont)}>
            {description && description}
            {descriptionLink && link ? (
              <Link prefetch={false} href={link} className={styles.desc_link}>
                {descriptionLink}
              </Link>
            ) : null}
            {button}
          </h2>
        )}
      </div>
    );
  }, [
    button,
    description,
    descriptionLink,
    dynamicFont,
    link,
    navigationBar,
    text,
    variant,
  ]);

  return (
    <div
      className={clsx(styles.container, dynamicStyle.classContainer)}
      id={anchor}
    >
      <div className={styles.container_s}>
        <div className={styles.wrapper}>
          <div className={styles.info_block} style={{ gap: gap }}>
            {dynamicContent}
          </div>
        </div>
      </div>
    </div>
  );
};
